var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49129 5.1989C8.18692 5.47985 8.16794 5.95435 8.4489 6.25871L13.9793 12.25L8.4489 18.2413C8.16794 18.5457 8.18692 19.0202 8.49129 19.3011C8.79566 19.5821 9.27015 19.5631 9.5511 19.2587L15.5511 12.7587C15.8163 12.4714 15.8163 12.0286 15.5511 11.7413L9.5511 5.24129C9.27015 4.93693 8.79566 4.91795 8.49129 5.1989Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.b77e418a532b9e8cbd07b9ac3ee289f8.svg";
export { ForwardRef as ReactComponent };